import type {
  CheckoutThemedHeading,
  OffersPageThemedHeading,
  ThemedHeading,
} from '@trmediaab/zebra';

const heading: ThemedHeading & CheckoutThemedHeading & OffersPageThemedHeading =
  {
    common: {
      lineHeight: 'medium',
      textRendering: 'optimizeLegibility',
    },
    h1: {
      // TODO
      variants: {
        default: {
          fontSize: [6, null, 8],
          fontWeight: 'extraBold',
        },
        offersPageHeader: {
          fontSize: [3, null, 6],
          fontWeight: 'extraBold',
        },
      },
    },
    h2: {
      variants: {
        default: {
          fontSize: [5, null, 6],
          fontWeight: 'regular',
        },
        paywallOffer: {
          fontSize: [5, null, '36px'],
          fontWeight: 'extraBold',
        },
        offersPageProduct: {
          fontSize: [4, null, 5],
          fontWeight: 'extraBold',
        },
        redeemCode: {
          fontSize: [5, null, 6],
          fontWeight: 'extraBold',
        },
      },
    },
    h3: {
      variants: {
        default: {
          fontSize: [3, null, 4],
          fontWeight: 'regular',
        },
      },
    },
    h4: {
      variants: {
        default: {
          fontSize: 1,
          fontWeight: 'bold',
        },
        checkout: {
          fontSize: [2, null, 3],
          fontWeight: 'bold',
        },
        offersPageBullets: {
          fontWeight: 'bold',
          color: 'orange',
        },
      },
    },
  };

export default heading;
